import { render, staticRenderFns } from "./ViewTrackingAndImpactionPoint.vue?vue&type=template&id=32b100f4&"
import script from "./ViewTrackingAndImpactionPoint.vue?vue&type=script&lang=js&"
export * from "./ViewTrackingAndImpactionPoint.vue?vue&type=script&lang=js&"
import style0 from "./ViewTrackingAndImpactionPoint.vue?vue&type=style&index=0&id=32b100f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports